import branchManagementLockOpenErrorsComponent from './lock_open_errors.component';

let branchManagementLockOpenErrorsModule = angular.module('branchManagementLockOpenErrors', [])
.component('branchManagementLockOpenErrors', branchManagementLockOpenErrorsComponent)
.name;

export default branchManagementLockOpenErrorsModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/lock_open_errors/index.js